import { ISegment } from './interfaces';

export const getParentSegments = (segments: ISegment[]) => {
  const parentSegmentAvids = [...new Set(segments.map((s) => s.segmentAvid))]
  const parentSegments = parentSegmentAvids.map((parentSegmentAvid) => segments.find((s) => s.segmentAvid === parentSegmentAvid))

  return parentSegments
    .filter((ps) => !!ps.segmentName)
    .sort((a1, a2) => a1.segmentName.localeCompare(a2.segmentName))
}
